/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

import "./CVSSData.css";

import * as React from "react";
import { CVSSDataProps, CVSSDataState } from "./CVSSData.types";

export default class CVSSData extends React.Component<CVSSDataProps, CVSSDataState> {

   private componentClassName: string;

   constructor(props: CVSSDataProps) {
      super(props);
      this.componentClassName = "cve_detail_cvss-data" + (this.props.componentName ? `-${this.props.componentName}` : "");
   }

   public render() {

      const cvss3 = this.props.impactData.baseMetricV3 ?

            <div>

               <div className="container">

                  <div>

                     <div className="column" style={{ fontWeight: "bold", color: "#777777" }}>
                        <div>Impact sub-score:</div>
                        <div>Expliotability sub-score:</div>
                        <div>&nbsp;</div>
                        <div>Attack vector (AV):</div>
                        <div>Attack complexity (AC):</div>
                        <div>Privileges required (PR):</div>
                        <div>User Interaction (UI):</div>
                        <div>Scope (S):</div>
                        <div>Confidentiality (C):</div>
                        <div>Integrity (I):</div>
                        <div>Availability (A):</div>
                     </div>

                     {/*
                     <div className="caption-margin">Temporal score metrics:</div><div></div>

                     <div className="column">
                        <div>Explotiability Code Maturity (E):</div>
                        <div>Remediation Level (RL):</div>
                        <div>Report Confidence (RC):</div>
                     </div>
                     */}

                  </div>

                  <div>

                     <div className="column">
                        <div>&nbsp;&nbsp;&nbsp;{this.props.impactData.baseMetricV3.impactScore || "N/A"}</div>
                        <div>&nbsp;&nbsp;&nbsp;{this.props.impactData.baseMetricV3.exploitabilityScore || "N/A"}</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;&nbsp;&nbsp;{this.props.impactData.baseMetricV3.cvssV3.attackVector}</div>
                        <div>&nbsp;&nbsp;&nbsp;{this.props.impactData.baseMetricV3.cvssV3.attackComplexity}</div>
                        <div>&nbsp;&nbsp;&nbsp;{this.props.impactData.baseMetricV3.cvssV3.privilegesRequired}</div>
                        <div>&nbsp;&nbsp;&nbsp;{this.props.impactData.baseMetricV3.cvssV3.userInteraction}</div>
                        <div>&nbsp;&nbsp;&nbsp;{this.props.impactData.baseMetricV3.cvssV3.scope}</div>
                        <div>&nbsp;&nbsp;&nbsp;{this.props.impactData.baseMetricV3.cvssV3.confidentialityImpact}</div>
                        <div>&nbsp;&nbsp;&nbsp;{this.props.impactData.baseMetricV3.cvssV3.integrityImpact}</div>
                        <div>&nbsp;&nbsp;&nbsp;{this.props.impactData.baseMetricV3.cvssV3.availabilityImpact}</div>
                     </div>

                     {/*
                     <div className="caption-margin">&nbsp;</div>

                     <div  className="column">
                        <div>value</div>
                        <div>value</div>
                        <div>value</div>
                     </div>
                     */}

                  </div>

               </div>


            </div>

         :
            <div></div>;



         const cvss2 = this.props.impactData.baseMetricV2 ?

               <div>

                  <div className="container">

                     <div>

                        <div className="column" style={{ fontWeight: "bold", color: "#777777" }}>
                           <div>Impact sub-score</div>
                           <div>Exploitability sub-score:</div>
                           <div>&nbsp;</div>
                           <div>Access Vector (AV):</div>
                           <div>Access Complexity (AC):</div>
                           <div>Authentication (Au):</div>
                           <div>Confidentiality Impact (C):</div>
                           <div>Integrity Impact (I):</div>
                           <div>Availability Impact (A):</div>
                        </div>

                        {/*
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>

                        <div className="caption-margin">Temporal score metrics:</div><div></div>

                        <div className="column">
                           <div>Explotiability Code Maturity (E):</div>
                           <div>Remediation Level (RL):</div>
                           <div>Report Confidence (RC):</div>
                        </div>
                        */}

                     </div>

                     <div>

                        <div  className="column">
                           <div>&nbsp;&nbsp;&nbsp;{this.props.impactData.baseMetricV2.impactScore}</div>
                           <div>&nbsp;&nbsp;&nbsp;{this.props.impactData.baseMetricV2.exploitabilityScore}</div>
                           <div>&nbsp;</div>
                           <div>&nbsp;&nbsp;&nbsp;{this.props.impactData.baseMetricV2.cvssV2.accessVector}</div>
                           <div>&nbsp;&nbsp;&nbsp;{this.props.impactData.baseMetricV2.cvssV2.accessComplexity}</div>
                           <div>&nbsp;&nbsp;&nbsp;{this.props.impactData.baseMetricV2.cvssV2.authentication}</div>
                           <div>&nbsp;&nbsp;&nbsp;{this.props.impactData.baseMetricV2.cvssV2.confidentialityImpact}</div>
                           <div>&nbsp;&nbsp;&nbsp;{this.props.impactData.baseMetricV2.cvssV2.integrityImpact}</div>
                           <div>&nbsp;&nbsp;&nbsp;{this.props.impactData.baseMetricV2.cvssV2.availabilityImpact}</div>
                        </div>

                        {/*
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>

                        <div className="caption-margin">&nbsp;</div>

                        <div className="column">
                           <div>value</div>
                           <div>value</div>
                           <div>value</div>
                        </div>
                        */}

                     </div>

                  </div>

               </div>

            :

               <div></div>


      return (

         <div className={this.componentClassName}>
            {cvss3}
            {cvss2}
         </div>

      )

   }

}